import React from 'react';

import { isEmpty } from 'ramda';

import { Alert } from 'components/shared/Alert';
import { FLIGHTS, getAlertWithAttention } from 'constants/texts';
import { EFlightStatus } from 'detailsv2/structure';

import { FlightAPIOption } from '../FlightAPIOption';
import { ISearchResultsProps } from '../types';
import s from './../index.module.css';
import { NoData } from './NoData';

export const SearchResults = ({
  activeItems,
  setActiveItems,
  searchResults,
  showSelect,
  isNoData,
  methods,
}: ISearchResultsProps) => {
  const { getValues } = methods;

  return (
    <div>
      {!isEmpty(activeItems) && Object.values(activeItems)[0]?.data?.flightStatus !== EFlightStatus.Common && (
        <Alert className={s.alert} variant="danger" content={getAlertWithAttention(FLIGHTS.ALERTS.CHANGE2)} />
      )}
      {isNoData ? (
        <NoData />
      ) : (
        searchResults &&
        searchResults.map((option, i) => {
          return (
            <FlightAPIOption
              key={option.airline.id + '_' + i}
              selectedOptions={activeItems}
              flightDate={getValues('data.flightDate')}
              airline={option.airline}
              flightNumber={option.flightNumber}
              departureTime={option.departureTime}
              arrivalTime={option.arrivalTime}
              departureAirport={option.departureAirport}
              arrivalAirport={option.arrivalAirport}
              setSelectedOptions={setActiveItems}
              isShowSelect={showSelect}
              flightStatus={option.flightStatus}
            />
          );
        })
      )}
    </div>
  );
};
